var render = function render(){var _vm=this,_c=_vm._self._c;return _c('div',{staticClass:"content"},[_c('div',{staticClass:"row"},[_c('div',{staticClass:"col col-md-12"},[_c('admin-stats-users-rating')],1)])])
}
var staticRenderFns = []

export { render, staticRenderFns }